import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useProfileScorecardFile = (link, type) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['profileScorecardFile', link, type],
    queryFn: async () => {
      const result = await restClient({
        url: `${prefix}/file?type=${type}&link=${link}`,
        responseType: 'blob'
      });
      return result;
    },
    enabled: !!link && !!type, 
    staleTime: 0,
    cacheTime: 0
  });
};
